import styled from 'styled-components';

import BasicDonutChart from 'components/common/chart/BasicDonutChart';
import { useGetGroupInsights } from 'hooks/queries/dashboard';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreLoading from 'shared/CoreLoading';
import { ReportSectionCard, ReportTopHeader } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

const mockData = {
	contentTypeDistribution: {
		friendlyExplanation: 0,
		personalStyling: 0,
		pointOfView: 0,
	},
};

function ContentsTypeStats() {
	const [groupId] = useGetSearchParams(['groupId']);

	const { data: groupInsights, isLoading: groupInsightsLoading } =
		useGetGroupInsights(groupId);

	// 가장 큰 값을 가진 key와 value를 추출
	const contentTypes =
		groupInsights?.contentTypeDistribution ?? mockData.contentTypeDistribution;
	const [largestKey, largestValue] = Object.entries(contentTypes).reduce(
		(max, current) => (current[1] > max[1] ? current : max),
		['', 0],
	);

	// 한글 매핑 (필요 시 추가)
	const contentTypeLabels: { [key: string]: string } = {
		friendlyExplanation: '친절한 설명형',
		personalStyling: '직접 피팅/연출형',
		pointOfView: 'POV형',
	};

	if (groupInsightsLoading) {
		return (
			<ReportSectionCard>
				<ReportTopHeader>콘텐츠 타입 분포</ReportTopHeader>
				<Grid flex="center" direction="column" _height="100%">
					<CoreLoading color_type="gray" />
				</Grid>
			</ReportSectionCard>
		);
	}

	return (
		<>
			<ReportSectionCard>
				<ReportTopHeader>콘텐츠 타입 분포</ReportTopHeader>
				<Grid flex="between" direction="column" align_items="start" _gap="24px">
					<Grid flex="start" align_items="end">
						<Text typo="h3">{contentTypeLabels[largestKey]}</Text>
						<Text typo="span_bold">({Math.round(largestValue ?? 0)}%)</Text>
					</Grid>
					<Grid _width="100%">
						<RelativeGrid>
							<AbsoluteChart>
								<BasicDonutChart
									value={[
										Math.round(contentTypes.friendlyExplanation),
										Math.round(contentTypes.personalStyling),
										Math.round(contentTypes.pointOfView),
									]}
									max_label={true}
									unit="%"
									value_name={[
										contentTypeLabels['friendlyExplanation'],
										contentTypeLabels['personalStyling'],
										contentTypeLabels['pointOfView'],
									]}
								/>
							</AbsoluteChart>
						</RelativeGrid>
					</Grid>
				</Grid>
			</ReportSectionCard>
		</>
	);
}

const { Grid, Text } = style;

const RelativeGrid = styled(Grid)`
	position: relative;
`;

const AbsoluteChart = styled.div`
	position: absolute;
	top: 30px;
`;

export default ContentsTypeStats;
